import react, { useState, useEffect } from 'react';
import { Button, Box } from '@mui/material';

const CancelButton = (props) => {
    return (
        <Box sx={{ Width: 200, height: 40 }}>
            <Button variant="outlined" color="primary" onClick={props.onClick} size="large" disabled={props.disabled}>
                Cancel
            </Button>
        </Box>
    );
}

export default CancelButton;